import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function OUTD1
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={42}
            adderFlag={22}
            labelBlock={'OUTD'}
            showLabelInput={true}
            userConfiguration={true}
        />
    );
}
export default OUTD1